var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConcluido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-31 -207H263V72C263 76.4183 259.418 80 255 80H-23C-27.4183 80 -31 76.4183 -31 72V-207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -13,
    y: -8,
    width: 108,
    height: 32,
    rx: 16,
    fill: "#D6FBD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C3.1402 0.5 0 3.6402 0 7.5C0 11.3598 3.1402 14.5 7 14.5C10.8598 14.5 14 11.3598 14 7.5C14 3.6402 10.8598 0.5 7 0.5ZM7 13.1C3.9123 13.1 1.4 10.5877 1.4 7.5C1.4 4.4123 3.9123 1.9 7 1.9C10.0877 1.9 12.6 4.4123 12.6 7.5C12.6 10.5877 10.0877 13.1 7 13.1Z",
    fill: "#49A96A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5993 8.6109L3.99 7.0044L3.0016 7.9956L5.6007 10.5891L10.2949 5.8949L9.3051 4.9051L5.5993 8.6109Z",
    fill: "#49A96A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 287,
    fill: "white",
    transform: "translate(-31 -207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcluido);
export default __webpack_public_path__ + "static/media/concluido.ed9aa719.svg";
export { ForwardRef as ReactComponent };